import type { PartSvgProps } from './types'

export default function ChargingHandleSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 80,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 80 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Horizontal bar (top) */}
      <rect x="8" y="12" width="64" height="14" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Vertical stem */}
      <rect x="32" y="26" width="16" height="28" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Latch tab — bottom */}
      <path d="M 28 54 L 52 54 L 56 68 L 24 68 Z"
            fill={fill} stroke={accent} strokeWidth="1.2" />
      {/* Latch pivot suggestion */}
      <line x1="40" y1="54" x2="40" y2="68"
            stroke={accent} strokeWidth="1" strokeDasharray="3 2" />
    </svg>
  )
}
